import type { WalletPaymentParentContext } from "@hsbc/types";
import type { State } from "xstate";

export type CommonStateType = State<WalletPaymentParentContext>;
export type CommonStateWithoutValue = Pick<CommonStateType, "context">;

export const getWalletCreditPayAmount = (state: CommonStateWithoutValue) =>
  state.context?.walletPayment?.creditPaymentAmount;

export const getWalletCreditBalance = (state: CommonStateWithoutValue) =>
  state.context?.walletPayment?.creditBalance;
